// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2usXx","left":"styles_left__2C-Om"};